import { render } from "./BankDetailsAddEditModal.vue?vue&type=template&id=4d20aedd"
import script from "./BankDetailsAddEditModal.vue?vue&type=script&lang=js"
export * from "./BankDetailsAddEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__